// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3WpSX","title":"BackImages_title__Z-T4s","images":"BackImages_images__3OVjI"};